import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../utils/api";
import { useAuth } from "./AuthContext";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const { user } = useAuth();
  const [applications, setApplications] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) { setApplications([]); return; }
    try { const { applications } = await api.request("/api/applications"); setApplications(applications); }
    catch { /* leave stale list in place rather than clearing it on a transient error */ }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const addApp = async (data) => {
    const { id } = await api.request("/api/applications", { method: "POST", body: data });
    refresh();
    return id;
  };

  const updateStatus = async (id, status, note = "") => {
    await api.request(`/api/applications/${id}/status`, { method: "PATCH", body: { status, note } });
    refresh();
  };

  const bulkStatus = async (ids, status) => {
    await api.request("/api/applications/bulk-status", { method: "POST", body: { ids, status } });
    refresh();
  };

  const deleteApps = async (ids) => {
    await api.request("/api/applications/delete", { method: "POST", body: { ids } });
    refresh();
  };

  const submitReview = async (id, rating, comment) => {
    await api.request(`/api/applications/${id}/review`, { method: "POST", body: { rating, comment } });
    refresh();
  };

  const getApp = (id) => applications.find(a => a.id === id);

  return (
    <AppContext.Provider value={{ applications, addApp, updateStatus, deleteApps, bulkStatus, getApp, submitReview, refresh }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
